export default __webpack_public_path__ + "static/media/duexpress.2e8d257a.png";